import axios from 'axios';

const getLocationById = (payload) => {
    return axios.post(process.env.REACT_APP_API_URL + '/api/reviews/', {
        action: "getLocationById",
        ...payload,
    });
}

const sendRating = (payload) => {
    return axios.post(process.env.REACT_APP_API_URL + '/api/reviews/', {
        action: "sendRating",
        ...payload,
    });
}

const sendFeedback = (payload) => {
    return axios.post(process.env.REACT_APP_API_URL + '/api/reviews/', {
        action: "sendFeedback",
        ...payload,
    });
}


const unsubscribe = (payload) => {
    return axios.post(process.env.REACT_APP_API_URL + '/api/reviews/', {
        action: "unsubscribe",
        ...payload,
    });
}

export const apiReviews = {
    getLocationById,
    sendRating,
    sendFeedback,
    unsubscribe,
}